// @flow

import React, { Component } from 'react';
import './MeasureSelector.css';

class MeasureSelector extends Component {
  render() {
    const { label, measures, onMeasureChange, selectedMeasure } = this.props;

    const onValueChange = event => {
      onMeasureChange({ value: event.target.value });
    };

    return (
      <div className="MeasureSelector">
        <div className="control">
          <label htmlFor="measureSelector">{label}</label>{' '}
          <select value={selectedMeasure.key} name="measureSelector" onChange={onValueChange}>
            {measures.map(m => {
              return (
                <option value={m.key} key={m.key}>
                  {m.label}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    );
  }
}

export default MeasureSelector;



// WEBPACK FOOTER //
// ./src/components/MeasureSelector/MeasureSelector.js